import React, { Fragment, useContext, useEffect } from "react";

import { Container, Row, Col, Card, CardBody } from "reactstrap";
import { Breadcrumbs, Btn } from "../../../AbstractElements";

import { ContatcCharges, Entities } from "../../../Shared/Constants";

import TableSearch from "../../../Shared/Components/Search/TableSearch";
import DataTableComponent from "./DataTableComponent";

import { PlusCircle } from "react-feather";

import JurisdictionForm from "./JurisdictionForm";
import JurisdictionContext from "./ContextProvider";
import { hasPermission } from "../../../Shared/Utils/userUtils";

const JurisdictionList = () => {
  const { modalTogle, setItem, setSearchTerm } =
    useContext(JurisdictionContext);
  const handleNew = (row) => {
    setItem({});
    modalTogle();
  };

  useEffect(() => {
    return () => {
      setSearchTerm("");
    };
  }, []);

  return (
    <Fragment>
      <Breadcrumbs
        parent="Admin"
        title={Entities}
        mainTitle={"Jurisdicciones"}
      />
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <Card>
              <CardBody className="data-tables">
                <Row className="project-list">
                  <Col md="4">
                    <TableSearch onSearch={setSearchTerm} />
                  </Col>
                  <Col sm="8" className="p-0">
                    {hasPermission("create_list") ? (
                      <div className="text-end">
                        <Btn
                          attrBtn={{
                            color: "primary",
                            className: "btn btn-primary text-white",
                            onClick: handleNew,
                          }}
                        >
                          <PlusCircle />
                          Nueva jurisdiccion
                        </Btn>
                        <JurisdictionForm />
                      </div>
                    ) : (
                      ""
                    )}
                  </Col>
                </Row>
                <Row className="mt-4">
                  <Col md="12">
                    <DataTableComponent />
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default JurisdictionList;
